export default __webpack_public_path__ + "static/media/background.ce62152c.jpg";